import { Link } from "react-router-dom";
const FooterSocial = () => {
  return (
    <div className="widget">
      <h3 className="widget-title mb-30">소셜 미디어</h3>
      <ul className="social-list list-horizontal">
        <li>
          <Link to="https://t.me/heuguchon_villagehall">
            <span className="fab fa-telegram" style={{ fontSize: "1.6rem" }}></span>
          </Link>
        </li>
        <li>
          <Link to="https://discord.gg/EF7zM7qFrt">
            <span className="fab fa-discord" style={{ fontSize: "1.6rem" }}></span>
          </Link>
        </li>
        <li>
          <Link to="https://www.youtube.com/@heuguchon_villagehall">
            <span className="fab fa-youtube" style={{ fontSize: "1.6rem" }}></span>
          </Link>
        </li>
        <li>
          <Link to="https://x.com/heuguchon">
            <span className="fab fa-x-twitter" style={{ fontSize: "1.6rem" }}></span>
          </Link>
        </li>
        <li>
          <Link to="https://github.com/heuguchon">
            <span className="fab fa-github" style={{ fontSize: "1.6rem" }}></span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default FooterSocial;
